import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const createPages = (data, perPage) => {
  return new Array(Math.ceil(data.length / perPage))
    .fill()
    .map((_, index) => {
      const start = index * perPage;
      return data.slice(start, start + perPage);
    });
};

export const SearchableDataGrid = (rows, columns, page, rowsPerPage = 100) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [search, setSearch] = useState('');
  const [pageIdx, setPageIdx] = useState(page);
  
  const handleSearchChange = useCallback((event) => {
    setSearch(event.target.value);
    setPageIdx(0);
  }, []);
  
  useEffect(() => {
    if (search) {
      const lowerCaseSearch = search.toLowerCase();
      const pages = createPages(rows, rowsPerPage);
      const currentPageData = pages[page] || [];
      const searchFilteredData = currentPageData.filter(row =>
        columns.some(column => row[column.field]?.toString().toLowerCase().includes(lowerCaseSearch)),
      );
      setFilteredRows(searchFilteredData);
    } else {
      setFilteredRows(rows);
      setPageIdx(page);
    }
  }, [search, rows, columns, page, rowsPerPage]);
  
  return { search, handleSearchChange, filteredRows, pageIdx };
};

SearchableDataGrid.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
};
